import { render, staticRenderFns } from "./fpshistory.vue?vue&type=template&id=3585600e&scoped=true&"
import script from "./fpshistory.vue?vue&type=script&lang=js&"
export * from "./fpshistory.vue?vue&type=script&lang=js&"
import style0 from "./fpshistory.vue?vue&type=style&index=0&id=3585600e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3585600e",
  null
  
)

export default component.exports